var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper",staticClass:"rich-text-editor",style:({ border: '1px solid #ccc', zIndex: 100 })})
}
var staticRenderFns = []

export { render, staticRenderFns }